import React from 'react';
import SidebarAccount from './SidebarAccount';
import { internalRoleLabel } from '../../internalRoleLabels';

const normalizeText = (value) => String(value || '').trim().replace(/\s+/g, ' ');
const ownerNames = new Set(['kris todi', 'johan todi', 'brian todi']);

// Presentation labels only. Access continues to use the stored maintenance role.
export function getInternalSidebarIdentity(user = {}) {
  const firstName = normalizeText(user.first_name || user.firstName);
  const lastName = normalizeText(user.last_name || user.lastName);
  const fullName = [firstName, lastName].filter(Boolean).join(' ')
    || normalizeText(user.fullName || user.name);
  const isBrianEmail = [user.email, user.username].some(
    (value) => normalizeText(value).toLowerCase() === 'brian@hudsonhvac.ca'
  );
  const name = fullName || (isBrianEmail ? 'Brian Todi' : '')
    || normalizeText(user.username || user.email) || 'Hudson user';
  const words = name.split(' ');
  const initials = (words.length > 1
    ? words[0][0] + words[words.length - 1][0]
    : name.slice(0, 2)).toUpperCase();

  return {
    name,
    initials,
    label: ownerNames.has(fullName.toLowerCase()) || isBrianEmail ? 'Owner' : internalRoleLabel(user.role) || 'Employee',
  };
}

export default function InternalSidebarAccount({ user, onLogout }) {
  const identity = getInternalSidebarIdentity(user);

  return (
    <SidebarAccount name={identity.name} subtitle={identity.label} initials={identity.initials} onLogout={onLogout} />
  );
}
